  <template>
  <div>
    <b-navbar toggleable="lg" type="dark" variant="dark">
      <b-navbar-brand  :to="{ path: '/' }">
      <font-awesome-icon :icon="['fas', 'tools']"/>
      Gestió d'incidències
      </b-navbar-brand>

      <b-navbar-toggle target="nav-collapse"></b-navbar-toggle>

      <b-collapse id="nav-collapse" is-nav>
        <b-navbar-nav>
          <b-nav-item @click.stop='' :active='$route.path =="/"' :to="{ path: '/' }"><b>Les meves incidències</b></b-nav-item>
          <b-nav-item @click.stop='' :active='$route.path =="/manager/grups"' v-if="this.user.userRole == 'Manager'" :to="{ path: '/manager/grups' }"><b>Incidències a gestionar</b></b-nav-item>
          <b-nav-item @click.stop='' :active='$route.path =="/manager/grups/history"' v-if="this.user.userRole == 'Manager'" :to="{ path: '/manager/grups/history' }"><b>Històric d'incidències</b></b-nav-item>
        </b-navbar-nav>
        <!-- Right aligned nav items -->

        <b-navbar-nav class="ml-auto">
          <b-nav-item right target="_blank" href="https://apps.escoladeltreball.org/manuals/tiquets/"><b>Ajuda</b></b-nav-item>
          <b-nav-item right>
            <div id="apps_menu">
              <button @click.stop='' @click="showIframe = !showIframe"><font-awesome-icon :icon="['fas', 'bars']"/></button>
              <iframe v-show="showIframe" v-if="src" :src="src"></iframe>
            </div>
          </b-nav-item>
        </b-navbar-nav>
      </b-collapse>
    </b-navbar>
  </div>
</template>
<script>
export default {
  computed: {
    user () {
      return this.$store.getters.getUser
    }
  },
  data () {
    return {
      src: process.env.VUE_APP_SESMAN,
      showIframe: false
    }
  }

}
</script>

<style scoped>

</style>
